module.exports = __webpack_public_path__ + "img/Mongolia.048d2b93.png";